exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root{--ds-interactions-fade-in:300ms ease-in;--ds-interactions-fade-out:300ms ease-in;--ds-interactions-transition:0.13s ease-in-out}", ""]);

// exports
